import React from 'react'

const forgotPassword = () => {
  return (
    <div style={{fontSize:'2rem'}}>forgotPassword</div>
  )
}

export default forgotPassword